import { useMutation, useQueryClient } from "react-query";
import { t } from "@/i18n-js/instance";
import { pageQueryKey } from "@/react/components/SettingsApp/Site/Pages/hooks/usePage";
import { useToast } from "@/react/components/shared/uikit/ToastV2";
import type { ApiError } from "@/react/config/CustomErrors";
import { reactQueryPatch } from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";
import type { Appearance } from "@circle-react-shared/BuilderUI/Store/interfaceSlice";
import { THEME_STATS_QUERY_KEY } from "./useGetThemeStats";

interface UpdatePageThemeData {
  appearance: Appearance;
  id: number;
}

export const useUpdatePageTheme = ({ pageId }: { pageId: number }) => {
  const queryClient = useQueryClient();
  const toast = useToast();

  return useMutation<{ id: number }, ApiError, UpdatePageThemeData>({
    mutationFn: ({ id, appearance }) =>
      reactQueryPatch(
        internalApi.settings.sites.pages.themes.update({ pageId }),
        {
          theme_id: id,
          appearance,
        },
      ),
    onSuccess: () => {
      void queryClient.invalidateQueries(pageQueryKey(pageId));
      void queryClient.invalidateQueries(THEME_STATS_QUERY_KEY);
      toast.success(t("changes_saved"));
    },
    onError: error => {
      toast.error(error.message || t("something_went_wrong"));
    },
  });
};
